import React from 'react'
import PropTypes from 'prop-types'
import { humi } from '../assets/assets'
import '../styles/d3/dialogueBox.scss'

const DialogueBox = props => {
  const { className, hasHumi, submission, children } = props
  return (
    <div
      className={`dialogue-box${className ? ` ${className}` : ''}${
        hasHumi ? ' has-humi' : ''
      }`}
    >
      {hasHumi && (
        <img
          className='humi'
          src={humi}
          alt='intro-humi'
          id={submission ? 'neo' : ''}
        />
      )}
      {children}
    </div>
  )
}

DialogueBox.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  hasHumi: PropTypes.bool,
  submission: PropTypes.bool
}

export default DialogueBox
